import React from "react";
import { useTranslation } from "react-i18next";

const HotelEnterYourDetails = () => {
  const { t } = useTranslation();
  return (
    <div>
      {/* Enter your details */}
      <div className="card-box p-25 mb-4">
        <h4 className="m-0">{t("Enter your details")}</h4>
        <div className="payment-box-card pt-3">
          <div className="row form-box-payment-new">
            <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="firstName">{t("First name")}</label>
                <input type="text" className="form-control" id="firstName" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="lastName">{t("Last name")}</label>
                <input type="text" className="form-control" id="lastName" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="email">{t("Email")}</label>
                <input type="email" className="form-control" id="email" />
                <span className="text-small">
                  {t("Confirmation email sent to this address")}
                </span>
              </div>
            </div>
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="country">{t("Country/Region")} <span>*</span></label>
                <select className="form-select" id="country">
                  <option defaultValue>{t("India")}</option>
                  <option value="1">{t("Aus")}</option>
                  <option value="2">{t("NZ")}</option>
                  <option value="3">{t("Eng")}</option>
                </select>
              </div>
            </div>
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <div className="mb-3 country-region-sec">
                <label htmlFor="phone">{t("Phone number")} <span>*</span></label>
                <div className="d-flex gap-2">
                  <select className="form-select" id="phoneCode">
                    <option defaultValue>+91</option>
                    <option value="1">+02</option>
                    <option value="2">+03</option>
                    <option value="3">+1</option>
                  </select>
                  <input type="text" className="form-control" id="phone" />
                </div>
                <span className="text-small">
                  {t("To verify your booking, and for the property to connect if needed")}
                </span>
              </div>
            </div>
            <div className="col-md-8">
              <div className="d-flex box-check-main gap-2">
                <input className="form-check-input" type="checkbox" id="flexCheckDefault"/>
                <div className="text-right-box">
                  {t("Yes, I want free paperless confirmation (recommended)")}
                  <span className="text-small d-block">
                    {t("We'll text you a link to download our app")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Deluxe Room */}
      <div className="card-box p-25 mb-4">
        <h4 className="m-0">{t("Deluxe Room")}</h4>
        <div className="listing-box-card pt-3">
          <ul>
            <li className="text-green">{t("Breakfast included in the price")}</li>
            <li className="text-green">{t("Includes late check-in + high-speed internet")}</li>
            <li className="text-green">{t("Free cancellation before September 25, 2025")}</li>
            <li>{t("Guests: ​2 adults")}</li>
            <li>{t("No smoking")}</li>
          </ul>
          <div className="mt-4 mx-450">
            <label htmlFor="guestName">{t("Full Guest Name")}</label>
            <input type="text" className="form-control" id="guestName" placeholder={t("First name Last name")}/>
          </div>
        </div>
      </div>

      {/* Special Requests */}
      <div className="card-box p-25 mb-4">
        <h4 className="m-0 mb-2">{t("Special requests")}</h4>
        <p>{t("Special requests can't be guaranteed, but the property will do its best to meet your needs. You can always make a special request after your booking is complete.")}</p>
        <div className="listing-box-card pt-3">
          <div className="textarea-form">
            <textarea className="form-control" id="specialRequest" rows="3" placeholder={t("Please write your requests in English.")}></textarea>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HotelEnterYourDetails;
